<template>
    <div class="loginBody">
        <!-- <login-nav></login-nav> -->
        <div class="listNav">
          <ul>
            <li v-for="(item, index1) in list" :key="item.nav">
              <div class="listNavDiv" :class="item.active ? 'active' : ''" @click="changeIndex(index1)">{{item.nav}}</div>
              <ul v-if="item.showYear">
                <li class="listNavYear" v-for="(years,index2) in item.yearList" :class="years.yearsShow ? 'year-active' : ''" @click="changeYear(index1,index2)">{{years.years}}</li>
              </ul>
            </li>
          </ul>
        </div>
        <div class="listDown">
            <el-row v-for="item in downList" :key="item.name" class="litsNum">
                <el-col :span="24"><a :href="item.url" class="downlink" :download="item.url">{{item.name}}</a></el-col>
                <!-- <el-col :span="4" style="text-align:center;"><a :href="item.url" class="downlink" :download="item.url">下载</a></el-col> -->
            </el-row>
        </div>
    </div>
</template>
<script>
  import LoginNav from '../../components/loginNav.vue';
	export default {
    components:{LoginNav},
		name: 'listDown',
		data () {
    		return {
    			list:[],
          downList:[],
    		}
    	},
		created(){
        this.getUrl();
      },
		methods:{
      getUrl: async function(){
        const data = {
          token:localStorage.getItem('token'),
        };
        // console.log(data);
        const res = await this.$axios.post('/project/SnsController/getFile.do',data);
        console.log(res);
        // this.list = res.data.data
        // this.list = JSON.parse(JSON.stringify(res.data.data))
        Object.values(res.data.data).forEach((val) =>{

          const data = {
            nav:'',//标题
            order:'',//区分标题的type
            list:[],//标题下面的数据，包括年份
            yearList:[],
            active:false,//所点击的标题
            showYear:false,//是否显示年份
          };

          data.nav=Object.keys(val)[0]//赋值标题
          data.order=Object.values(val)[1]//赋值order

          const newList = Object.values(val)[0];
          // console.log(newList);
          // console.log(Object.keys(newList));
          // console.log(Object.values(newList));

          data.list = [...Object.values(newList)]
          // data.yearList = [...Object.keys(newList)]
          // console.log(Object.keys(newList));
          Object.keys(newList).forEach((vals) =>{
            // console.log(vals);
            const valsData = {
              years:vals,
              yearsShow:false,
            }
            data.yearList.push(valsData);
          })


          const apiList = Object.values(val)[0];
          console.log(apiList);
          data.list=[...apiList,...data.list]
          console.log(data);
          this.list.push(data);
        })


        // console.log(this.list);
        this.list[0].active=true;
        this.list[0].list.forEach((vals) => {
          // for(let i = 0;i<vals.length;i++){
          //   this.downList.push(vals[i])
          // }
          this.downList.push.apply(this.downList,vals);
        })
        if(this.list[0].order == 1){
          this.insertionSort(this.downList)
        }
      },

      changeIndex(i){
        // console.log(i);
        this.list.forEach((val)=>{
          val.active = false;
          val.showYear = false;
        })

        this.list[i].active=true;
        console.log(this.list[i].order);
        // this.downList = [...this.list[i].list]
        this.downList = [];

        if(this.list[i].order == 4){
          this.list[i].yearList.forEach((val)=>{
            val.yearsShow = false;
          })
          this.list[i].showYear = true;
          this.list[i].yearList[0].yearsShow = true;
          this.downList = this.list[i].list[0];
        }else if(this.list[i].order == 5){
          this.list[i].yearList.forEach((val)=>{
            val.yearsShow = false;
          })
          this.list[i].showYear = true;
          this.list[i].yearList[0].yearsShow = true;
          this.downList = this.list[i].list[0];
        }else{
          this.list[i].list.forEach((vals) => {
            this.downList.push.apply(this.downList,vals);
          })
        }

        if(this.list[i].order == 1){
          this.insertionSort(this.downList)
        }
        
      },
      insertionSort(arr) {
        for (let i = 1, len = arr.length; i < len; i++) {
          const temp = arr[i];
          let preIndex = i - 1;

          while (arr[preIndex].orderBy > temp.orderBy) {
            arr[preIndex + 1] = arr[preIndex];
            preIndex -= 1;
          }
          arr[preIndex + 1] = temp;
        }
        arr.reverse();
        return arr;
      },

      changeYear(i1,i2){
        this.downList = [];
        this.list[i1].yearList.forEach((val)=>{
          val.yearsShow = false;
        })
        this.list[i1].yearList[i2].yearsShow = true;
        this.downList = this.list[i1].list[i2];
        console.log(i1);
        console.log(i2);
      }


    },
	}
</script>
<style>
.listDown{
    width:80%;
    margin:0 0 100px;
    padding:40px 0 0 0;
}
.loginBody{
  min-width:300px;
  max-width:1200px;
  width:90%;
  background:#fff;
  padding:0 0 60px 0;
  margin:25px auto 0;
  display: flex;
  justify-content: space-between;
  border-top:1px solid #d2d2d2;
}
.litsNum{
	font-size: 18px;
	color: #848e9f;
	line-height:60px;
	border-bottom:1px solid #ccc;
}

.downlink{
    color:#848e9f;
    text-decoration: none;
}
.downlink:hover{
    color:#cfb284;
    text-decoration: underline;
}
.listNav{
  padding:40px 20px 20px;
  border-right:1px solid #d2d2d2;
}
.listNav li{
  line-height:60px;
  cursor: pointer;
  color:#858585;
  box-sizing: border-box;
  transition:color .5s;
-moz-transition:color .5s; /* Firefox 4 */
-webkit-transition:color .5s; /* Safari and Chrome */
-o-transition:color .5s; /* Opera */
}
.listNav li .active,.listNavDiv:hover{
  color:#ff8c00;
  border-bottom:3px solid #ff8c00;
}
.listNavYear{text-align:right;}
.listNavYear:hover,.listNav li.year-active{
  color:#ff8c00;
}
</style>


// WEBPACK FOOTER //
// src/pages/homeChild/listDown.vue